import { createFileRoute } from '@tanstack/react-router'
import { CostEntriesListPage } from '../../../../features/projects/cost-entry-pages'
import { costEntrySearchSchema } from '../../../../features/projects/search'

export const Route = createFileRoute('/_app/projects/cost-entries/')({
  validateSearch: costEntrySearchSchema,
  component: CostEntriesListPage,
})
